export const goalsTabIds = {
  vision: 'vision',
  goals: 'goals',
  initiatives: 'initiatives',
  ideas: 'ideas',
  activity: 'activity'
}
